<template>
  <v-app-bar id="app-bar" shrink-on-scroll prominent elevate-on-scroll app>
    <router-link class="logo-container ripple" :to="{ name: 'home-page' }">
      <img class="app-bar-image" height="100%;" src="../../assets/Real-Deal.svg" />
    </router-link>
    <v-spacer></v-spacer>
    <div class="app-bar-links">
      <nav-button :navTo="{ name: 'register' }" iconString="far fa-registered" toolTip="Register"></nav-button>
      <nav-button v-if="allowReg" :navTo="{ name: 'business-login' }" iconString="fas fa-sign-in-alt" toolTip="Sign In"></nav-button>
    </div>
  </v-app-bar>
</template>

<script>
import NavButton from './NavButton';

export default {
  name: 'public-navigation',
  components: {
    'nav-button': NavButton,
  },
  computed: {
        isLive() {
            return process.env.VUE_APP_DATENIGHT_IS_LIVE == 'true';
        }
    }
};
</script>
